export interface User {
  id?: string;
  role: string;
  username: string;
  email: string;
  password: string;
  profile_img: string;
  first_name: string;
  last_name: string;
  name: string;
  address: string;
  city: string;
  occupation: string;
  other: string;
  country: string;
  birthday: Date;
  national_identity_no: string;
  phone_no: string;
  phone_no_code: string;
  description: string;
  is_email_verified: boolean;
  is_phone_verified: boolean;
  is_online: boolean;
  is_bussiness_skipped?: boolean;
  business_name: string;
  business_address: string;
  business_description: string;
  accepted_tc_sign: boolean;
  status: string;
  blocked_reason: string;
  block_expiry_date: number;
  primium_type: string;
  primium_expiry_date: number;
  app_version: string;
  created_at: Date;
  updated_at: Date;
  plan?: {
    type: string;
    price: number;
  };
  // New subscription fields from updated API
  subscription_status?: string; // NONE, TRIAL, ACTIVE, PAST_DUE, PAUSED, CANCELED
  trial_ends_at?: number | null;
  next_billing_date?: number | null;
  cancel_at_period_end?: boolean;
  cancel_effective_at?: number | null;
  pending_plan_type?: string | null;
  pending_plan_effective_at?: number | null;
  billing_error_count?: number;
}

export const EMPTY_USER: User = {
  id: "",
  role: "",
  username: "",
  email: "",
  password: "",
  profile_img: "",
  first_name: "",
  last_name: "",
  name: "",
  address: "",
  city: "",
  occupation: "",
  other: "",
  country: "",
  birthday: new Date(),
  national_identity_no: "",
  phone_no: "",
  phone_no_code: "",
  description: "",
  is_email_verified: false,
  is_phone_verified: false,
  is_online: false,
  is_bussiness_skipped: false,
  business_name: "",
  business_address: "",
  business_description: "",
  accepted_tc_sign: false,
  status: "",
  blocked_reason: "",
  block_expiry_date: 0,
  primium_type: "",
  primium_expiry_date: 0,
  app_version: "",
  plan: {
    type: "",
    price: 0,
  },
  created_at: new Date(),
  updated_at: new Date(),
  // New subscription fields
  subscription_status: undefined,
  trial_ends_at: null,
  next_billing_date: null,
  cancel_at_period_end: false,
  cancel_effective_at: null,
  pending_plan_type: null,
  pending_plan_effective_at: null,
  billing_error_count: 0,
};
